import React from "react";
import { useParams } from "react-router-dom";
import { UMHeaderDarkOpenNoLogout } from "../../components/header/umheader_dark-open-no-logout";
import { InlineAssistant } from "../../partials/reference-library/ref-library-item/inline-assistant";
import { MS_IWCE_ASSIST_CLOSE_MESSAGE } from "../../constants/iwce-assist-embed";

export const IWCEAssist = () => {
    const { token } = useParams<{ token: string }>();

    console.log("token in custom assist", token);

    localStorage.setItem("token", atob(token || ""));

    return <div className="flex flex-col flex-1 p-4">
        <div className="absolute top-0 left-0 w-full">
            <UMHeaderDarkOpenNoLogout />
        </div>
        <div
            className="text-xl font-normal logo-icon sm:text-xl pb-1.5 pt-1"
            // style={{ color: "#055B7F" }}
            style={{ color: "#57ccf2" }}
        >
            MINDSTRENGTH Assist_
        </div>
        <InlineAssistant
            disableInitiativeClick={true}
            assignedInitiativeIds={[]}
            refetchInitiatives={() => Promise.resolve()}
            toggle={() => { }}
            onAllDone={() => {
                if (window.parent !== window.self) {
                    window.parent.postMessage(MS_IWCE_ASSIST_CLOSE_MESSAGE, "*");
                }
            }}
        />
    </div>;
};
